import { useEffect } from 'react';

import Audio from 'UiKit/audio';
import sound from 'Asset/sound/sound-violation.mp3';

const AudioViolation = ({ id = 'camera-violation__sound' }) => {
  const AUDIO_REPEAT = 15;

  const audioElement = document.getElementById(id);

  useEffect(() => {
    audioElement?.play();
    const timer = setInterval(() => audioElement?.play(), AUDIO_REPEAT * 1000 + 200);
    return () => clearInterval(timer);
  }, [audioElement]);

  return <Audio src={sound} id={id} data-testid={id} />;
};

export default AudioViolation;
